/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Notifications_ExpiredInputs */

const he_account_notifications_expired = /** @type {(inputs: Account_Notifications_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פג תוקף`)
};

const en_account_notifications_expired = /** @type {(inputs: Account_Notifications_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expired`)
};

/**
* | output |
* | --- |
* | "Expired" |
*
* @param {Account_Notifications_ExpiredInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_notifications_expired = /** @type {((inputs?: Account_Notifications_ExpiredInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Notifications_ExpiredInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_notifications_expired(inputs)
	return en_account_notifications_expired(inputs)
});